var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'nuxt-link' : 'button',_vm._g({tag:"component",class:[
    'base-button',
    { 'disabled': _vm.disabled }
  ],attrs:{"to":_vm.link,"aria-disabled":_vm.disabled}},!_vm.disabled ? _vm.$listeners : {}),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }